import { Navigate, Route, Routes } from 'react-router-dom'
import AppShell from '@/layouts/app-shell'
import AdministradoresList from '@/views/administradores/list'
import AutorizacoesDetail from '@/views/autorizacoes/detail'
import AutorizacoesList from '@/views/autorizacoes/list'
import ClientesList from '@/views/clientes/list'
import Configuracoes from '@/views/configuracoes'
import CredenciaisDetail from '@/views/credenciais/detail'
import CredenciaisList from '@/views/credenciais/list'
import Dashboard from '@/views/dashboard'
import ForgotPassword from '@/views/authentication/forgot-password'
import Login from '@/views/authentication/login'
import NotFound from '@/views/misc/not-found'
import OperadoresList from '@/views/operadores/list'
import RelatoriosView from '@/views/relatorios'
import TiposCredenciaisDetail from '@/views/tipos-credenciais/detail'
import TiposCredenciaisList from '@/views/tipos-credenciais/list'
import { ACAO } from '@/utility/permissions'
import { PermissionRoute, PrivateRoute, PublicRoute } from './guards'

const Router = () => (
  <Routes>
    <Route element={<PublicRoute />}>
      <Route path="/login" element={<Login />} />
      <Route path="/esqueceu-senha" element={<ForgotPassword />} />
    </Route>

    <Route element={<PrivateRoute />}>
      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/autorizacoes" element={<AutorizacoesList />} />
        <Route path="/autorizacoes/:guiaId" element={<AutorizacoesDetail />} />
        <Route path="/credenciais" element={<CredenciaisList />} />
        <Route path="/credenciais/:credencialId" element={<CredenciaisDetail />} />
        <Route path="/tipos-credenciais" element={<TiposCredenciaisList />} />
        <Route path="/tipos-credenciais/:tipoCredencialId" element={<TiposCredenciaisDetail />} />
        <Route path="/configuracoes" element={<Configuracoes />} />

        <Route element={<PermissionRoute acao={ACAO.EditarCliente} />}>
          <Route path="/clientes" element={<ClientesList />} />
        </Route>
        <Route element={<PermissionRoute acao={ACAO.VerRelatorios} />}>
          <Route path="/relatorios" element={<RelatoriosView />} />
        </Route>
        <Route element={<PermissionRoute acao={ACAO.GerenciarOperadores} />}>
          <Route path="/operadores" element={<OperadoresList />} />
        </Route>
        <Route element={<PermissionRoute acao={ACAO.GerenciarAdministradores} />}>
          <Route path="/administradores" element={<AdministradoresList />} />
        </Route>
      </Route>
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
)

export default Router
